import { Anchor } from "../../app/components/anchor"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import MSAsJson from "../../constants/cost-to-ship/MSAsJson"
import { urlifyName } from "../../constants/stateCityDictionary"
import * as config from "../../util/config"

export default function OtherAreas({ metroName }: { metroName: string }) {
  const host = config.getWebsiteHost()
  return (
    <section className="header-padding bg-gradient-to-b from-[#FBF3C6] via-white to-white">
      <h3 className="mb-3 font-montserrat font-semibold text-3xl text-center">
        Ready to make the move to the {metroName} area?
      </h3>
      <p className="mb-8 text-xl text-gray7 text-center">
        No hidden costs or upcharges. Just a simple and stress-free experience.
        <br />
        Get started in two minutes or less!
      </p>
      <PrimaryButton
        className="block w-80 mb-24 mx-auto"
        onClick={() => window.location.assign(`${host}/shipments/new`)}
      >
        Get Free Estimates
      </PrimaryButton>
      <h4 className="max-w-2xl mb-8 mx-auto text-center text-2xl font-montserrat font-semibold">
        Looking for how much it’ll cost to ship your pets or precious items to
        other areas?
      </h4>
      <nav className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-lg">
        {MSAsJson.map((msa) => (
          <Anchor href={`${urlifyName(msa.name)}`} key={msa.name}>
            {msa.name}
          </Anchor>
        ))}
      </nav>
    </section>
  )
}
